"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.pruneNull = void 0;
/**
 * A helper function to recursively remove null values from an object
 * Removes keys with null values and list items equal to null
 * Does NOT affect undefined values
 *
 * e.g. [{ a: null, b: "spoon" }, null] -> [{ b: "spoon" }]
 */
function pruneNull(obj) {
    if (Array.isArray(obj)) {
        return obj.filter((v) => v !== null).map((o) => pruneNull(o));
    }
    // @ts-ignore
    const entries = Object.entries(obj).filter(([_k, value]) => {
        return value !== null;
    });
    return Object.fromEntries(entries);
}
exports.pruneNull = pruneNull;
//# sourceMappingURL=pruneNull.js.map